<div class="report-page-root-container daily-sales-report-component-container">
  <div class="page-content">
    <div class="page-header">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis" style="width:27px">
        <path
          d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
          data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation">
        </path>
      </svg> -->
      <img class="icon" src="assets/images/menu/svg/daily-sales-report.svg" width="27">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        <!-- @if(permission.can_export || permission.can_execute){ -->
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon"
            [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
          <span class="action-btn-title">Export</span>
        </button>
        <!-- } -->
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="navigateToDailySalesReportView()">View</button> -->
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">

            <div class="row">
              @if (this.user?.user_type != 'SHOP') {
              <mat-form-field class="shop-selection">
                <mat-label>Shop</mat-label>
                <input matInput formControlName="shop_id" [matAutocomplete]="shopAuto" (input)="filterShops()"
                  (focus)="filterShops()" autocomplete="off" placeholder="Select a shop">
                <button *ngIf="editForm.get('shop_id')?.value" matSuffix mat-icon-button aria-label="Clear"
                  (click)="clearShop()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #shopAuto="matAutocomplete" [displayWith]="displayShop">
                  <mat-option *ngFor="let shop of filteredShopList" [value]="shop">
                    <span>
                      {{ shop.name }}
                    </span>
                  </mat-option>
                </mat-autocomplete>
                <mat-error
                  *ngIf="editForm.get('shop_id')?.invalid && (editForm.get('shop_id')?.touched || editForm.get('shop_id')?.dirty)">
                  <ng-container
                    *ngIf="editForm.get('shop_id')?.hasError('invalidShop') || editForm.get('shop_id')?.hasError('required')">
                    Please select a valid shop.
                  </ng-container>
                </mat-error>
              </mat-form-field>
              }
              <mat-form-field class="filter-year">
                <mat-label>Year</mat-label>
                <mat-select placeholder="Select a year" formControlName="year" (selectionChange)="onYearChange()">
                  <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                    {{ fy.display_year }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="week-selection">
                <mat-label>Week From</mat-label>
                <mat-select formControlName="weekFrom">
                  <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                    {{ week.displayText }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="editForm.get('weekFrom')?.hasError('required') && (editForm.get('weekFrom')?.touched || editForm.get('weekFrom')?.dirty)">
                  Please select a starting week.
                </mat-error>
              </mat-form-field>
              <mat-form-field class="week-selection">
                <mat-label>Week To</mat-label>
                <mat-select formControlName="weekTo">
                  <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                    {{ week.displayText }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="editForm.get('weekTo')?.hasError('required') && (editForm.get('weekTo')?.touched || editForm.get('weekTo')?.dirty)">
                  Please select an ending week.
                </mat-error>
                <mat-error *ngIf="editForm.get('weekTo')?.hasError('invalidWeekRange') &&
         (editForm.get('weekTo')?.touched || editForm.get('weekTo')?.dirty)">
                  Week To must be after Week From.
                </mat-error>
              </mat-form-field>
              <!-- <mat-form-field>
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY"
                  required>
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.hasError('required') && editForm.get('period_from')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field> -->
            </div>
            <div class="input-group" style="display: none;">
              <mat-form-field class="example-full-width">
                <mat-label>Shift</mat-label>
                <input matInput value="Daily shift" formControlName="shift_from">
              </mat-form-field>
            </div>


            <!-- Terminal Dropdown -->
            <!-- Terminal Dropdown -->
            <div class="list-row shops">
              <div class="header" (click)="isExpandedTerminal = !isExpandedTerminal">
                <div class="title-container">
                  <span class="title">Terminal</span>
                  <span class="count" *ngIf="selectedTerminalSourcesCount > 0">
                    [ {{selectedTerminalSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedTerminal" class="list-action-button"
                    (click)="showSelectedTerminalOnly = !showSelectedTerminalOnly"
                    [title]="showSelectedTerminalOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedTerminalOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedTerminal" class="list-action-button" (click)="toggleSelectAllTerminal()"
                    title="Select All/None">
                    <mat-icon>{{ getSelectAllIconTerminal() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedTerminal = !isExpandedTerminal">
                    <mat-icon>{{ isExpandedTerminal ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="isExpandedTerminal" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Terminal" formControlName="terminalFilterAll">
                      <button *ngIf="editForm.get('terminalFilterAll')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('terminalFilterAll')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredTerminalListData">
                      <div class="list-item"
                        (click)="item.selected = !item.selected; onListSelectionChange('terminal')">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onListSelectionChange('terminal')">
                          {{ item.item.name }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          <div class="list-row shops">
  <div class="header" (click)="isExpandedUserGroup = !isExpandedUserGroup">
    <div class="title-container">
      <span class="title">User Group</span>
      <span class="count" *ngIf="selectedUserGroupSourcesCount > 0">
        [ {{selectedUserGroupSourcesCount}} ]
      </span>
    </div>
    <div class="toggle-action-container">
      <button *ngIf="isExpandedUserGroup" class="list-action-button"
        (click)="$event.stopPropagation(); showSelectedUserGroupOnly = !showSelectedUserGroupOnly"
        [title]="showSelectedUserGroupOnly ? 'Show All' : 'Show Selected Only'">
        <mat-icon>{{ showSelectedUserGroupOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <button *ngIf="isExpandedUserGroup" class="list-action-button" 
        (click)="$event.stopPropagation(); toggleSelectAllUserGroup()"
        title="Select All/None">
        <mat-icon>{{ getSelectAllIconUserGroup() }}</mat-icon>
      </button>
      <button class="list-action-button">
        <mat-icon>{{ isExpandedUserGroup ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="isExpandedUserGroup" class="list">
    <div class="item-list">
      <div class="content-filter">
        <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
          <input matInput placeholder="Filter User Group" formControlName="userGroupFilterAll">
          <button *ngIf="editForm.get('userGroupFilterAll')?.value" matSuffix mat-icon-button
            aria-label="Clear" (click)="editForm.get('userGroupFilterAll')?.setValue('')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="content">
        <!-- <ng-container *ngFor="let item of filteredUserGroupListData">
          
          <div class="list-item" (click)="item.selected = !item.selected; onUserGroupChange()">
  <mat-checkbox 
    [checked]="item.selected" 
    (click)="$event.stopPropagation()"
    (change)="item.selected = !item.selected; onUserGroupChange()">
    {{ item.item.name }}
  </mat-checkbox>
</div>
        </ng-container> -->
        <ng-container *ngFor="let item of filteredUserGroupListData">
  <div class="list-item" (click)="item.selected = !item.selected; onUserGroupChange()">
    <mat-checkbox [checked]="item.selected" 
                  (click)="$event.stopPropagation()"
                  (change)="item.selected = !item.selected; onUserGroupChange()">
      {{ item.item.name }}
    </mat-checkbox>
  </div>
</ng-container>
      </div>
    </div>
  </div>
</div>
          

            <!-- Cashier Dropdown -->
            <!-- Cashier Dropdown -->
            <!-- <div class="list-row shops">
              <div class="header" (click)="isExpandedCashier = !isExpandedCashier">
                <div class="title-container">
                  <span class="title">Cashier</span>
                  <span class="count" *ngIf="selectedCashierSourcesCount > 0">
                    [ {{selectedCashierSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedCashier" class="list-action-button"
                    (click)="showSelectedCashierOnly = !showSelectedCashierOnly"
                    [title]="showSelectedCashierOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedCashierOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedCashier" class="list-action-button" (click)="toggleSelectAllCashier()"
                    title="Select All/None">
                    <mat-icon>{{ getSelectAllIconCashier() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedCashier = !isExpandedCashier">
                    <mat-icon>{{ isExpandedCashier ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="isExpandedCashier" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Cashier" formControlName="cashierFilterAll">
                      <button *ngIf="editForm.get('cashierFilterAll')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('cashierFilterAll')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredCashierListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onListSelectionChange('cashier')">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onListSelectionChange('cashier')">
                          {{ item.item.name }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div> -->


              <div class="list-row shops">
              <div class="header" (click)="isExpandedUser = !isExpandedUser">
                <div class="title-container">
                  <span class="title">Users</span> <span class="count" *ngIf="selectedUserSourcesCount > 0">
                    [ {{selectedUserSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedUser" class="list-action-button"
                    (click)="$event.stopPropagation(); showSelectedUserOnly = !showSelectedUserOnly">
                    <mat-icon>{{ showSelectedUserOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedUser" class="list-action-button"
                    (click)="$event.stopPropagation(); toggleSelectAllUser()">
                    <mat-icon>{{ getSelectAllIconUser() }}</mat-icon>
                  </button>
                  <button class="list-action-button">
                    <mat-icon>{{ isExpandedUser ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="isExpandedUser" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Users" formControlName="userFilterAll">
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredUserListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected">
                          {{ item.item.name }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="input-group days">
              <div class="input-box-left">
                <div class="day">Day</div>
              </div>
              <div class="input-box-right" formGroupName="days">
                <mat-checkbox *ngFor="let day of daysOfWeek" [formControlName]="day">
                  {{ day }}
                </mat-checkbox>
              </div>
            </div> -->
            <!-- <div class="input-group">
              <div>
                Exclude sales details
                <mat-checkbox></mat-checkbox>
              </div>
              <div>

              </div>

            </div> -->
            <!-- <div class="input-group">
              <div>
                Exclude expenses details
                <mat-checkbox></mat-checkbox>
              </div>
              <div>
              </div>

            </div> -->
            <!-- <div class="input-group">
              <mat-form-field style="width: 250px;">
                <mat-label>Percentage Calculation</mat-label>
                <mat-select formControlName="percentage_calculation">
                  <mat-option [value]="0">
                    Total Sales Amount
                  </mat-option>
                  <mat-option [value]="1">
                    Total Units Sold
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>From (Hours)</mat-label>
                <mat-select formControlName="fromHour">
                  <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill">
                <mat-label>To (Hours)</mat-label>
                <mat-select formControlName="toHour">
                  <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="editForm.errors?.['invalidHourRange'] && editForm.touched" class="error">
                Invalid time duration.
              </div>
              <div style="margin-top: 8px;margin-left: 15px;">
                <mat-label>Summary Report</mat-label>
                <mat-checkbox formControlName="summary_report"></mat-checkbox>
              </div>
            </div> -->
          </div>
        </div>
      </form>
    </div>
  </div>
</div>